import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const featuredProducts = productData.slice(0, 4);

  return (
    <div className="main">
      <main>
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-image">
            <img src="/main/tuddle-hero-1.png" alt="Tuddlepetgoods jewelry collection" />
          </div>
        </section>

        {/* Featured Products Section */}
        <section className="featured-section">
          <div className="section-header">
            <h2>NEW ARRIVALS</h2>
            <Link to="/shop" onClick={toTop} className="view-all-link">
              VIEW ALL
            </Link>
          </div>
          <div className="products-grid">
            {featuredProducts.map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                onClick={toTop}
                className="product-card"
              >
                <div className="product-image">
                  <img src={product.image.replace(".jpeg", ".webp")} alt={product.name} />
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Second Hero Section */}
        <section className="second-hero-section">
          <div className="hero-image">
            <img src="/main/tuddle-hero-2.png" alt="Tuddlepetgoods jewelry styling" />
          </div>
        </section>

        {/* Vintage Collection Section */}
        <section className="vintage-section">
          <div className="section-header">
            <h2>VINTAGE COLLECTION</h2>
            <Link to="/shop" onClick={toTop} className="view-all-link">
              VIEW ALL
            </Link>
          </div>
          <div className="products-grid">
            {productData.slice(4, 8).map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                onClick={toTop}
                className="product-card"
              >
                <div className="product-image">
                  <img src={product.image.replace(".jpeg", ".webp")} alt={product.name} />
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>

     
      </main>
    </div>
  );
}

export default Main;
